export default (price: number) => {
	const priceToFormat = price ? (price / 100) : 0;

	return priceToFormat.toLocaleString('fr-FR', {
		currency: 'EUR',
		style: 'currency',
	});
};
